/* NINEPADEL basket: drawer open/close + client-side render from cart JSON for every [data-np-cart] root (drawer and basket page).
   Listens for 'np:cart:changed' (detail = cart JSON) and 'np:cart:open' from np-core.js. */
(function(){
  var NP = window.NP = window.NP || {};
  var drawer = document.querySelector('[data-np-drawer]');
  var isCartPage = !!document.querySelector('[data-np-cart="page"]');
  var cfg = {}; try { var el = document.querySelector('[data-np-cart-config]'); if(el) cfg = JSON.parse(el.textContent); } catch(e){}
  var levels = cfg.levels || {};
  var lastFocus = null;

  /* money in the shop's format with pence, to match Liquid's | money */
  function money(c){
    var fmt = NP.money || '£{{amount}}';
    var n = (Math.round(c) / 100);
    var two = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var none = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, none).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two.replace(/,/g,'#').replace('.', ',').replace(/#/g,'.')).replace(/\{\{\s*amount\s*\}\}/, two).replace(/<[^>]*>/g,'');
  }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function img(u, w){ if(!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var TH = (typeof NP.freeShip === 'number') ? NP.freeShip : 10000;

  /* harvest level data from server-rendered lines */
  document.querySelectorAll('.line[data-pid][data-lvl]').forEach(function(l){
    if(l.dataset.lvl && !levels[l.dataset.pid]) levels[l.dataset.pid] = { txt: l.dataset.lvl, top: +l.dataset.lvt };
  });
  function levelOf(pid){
    var v = levels[pid]; if(!v) return null;
    if(v.txt) return v;
    if(Array.isArray(v) && v.length){
      var top = 0; if(v.indexOf('Intermediate') > -1) top = 1; if(v.indexOf('Advanced') > -1) top = 2;
      return { txt: v.length > 1 ? v[0] + ' → ' + v[v.length-1] : v[0], top: top };
    }
    return null;
  }

  /* ---------- templates (mirror snippets/np-cart-line + np-cart-fdb) ---------- */
  function lineHtml(it){
    var lv = levelOf(it.product_id), meta = [];
    if(lv) meta.push('<span class="lvm" aria-hidden="true">' + [0,1,2].map(function(i){ return '<i' + (i <= lv.top ? ' class="on"' : '') + '></i>'; }).join('') + '</span>' + esc(lv.txt));
    if(!it.product_has_only_default_variant && it.variant_title) meta.push(esc(it.variant_title));
    (it.line_level_discount_allocations || []).forEach(function(d){ if(d.discount_application && d.discount_application.title) meta.push(esc(d.discount_application.title)); });
    var props = [], pr = it.properties || {};
    Object.keys(pr).forEach(function(k){ if(k.charAt(0) !== '_' && pr[k]) props.push(esc(k) + ': ' + esc(pr[k])); });
    var extra = (props.length ? '<span class="meta props">' + props.join(' · ') + '</span>' : '') + (pr._Lead ? '<span class="meta lead">' + esc(pr._Lead) + '</span>' : '');
    var t = esc(it.product_title);
    var fgc = window.NP_FREEGRIP, fgWas = fgc && fgc.was ? fgc.was[String(it.variant_id)] : 0, fg = it.product_type === 'Free Gift';
    return '<div class="line" data-key="' + esc(it.key) + '" data-pid="' + it.product_id + '">' +
      '<a class="im" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (it.image ? '<img src="' + esc(img(it.image, 240)) + '" alt="" loading="lazy">' : '') + '</a>' +
      (fg ? '<div class="t"><div class="top"><span class="n"><b class="n">' + t + '</b></span><span class="pr"><b style="color:#3F6212">Free</b>' + (fgWas ? '<s>' + money(fgWas * it.quantity) + '</s>' : '') + '</span></div><span class="meta">' + esc(it.variant_title || '') + ' · with your racket</span></div></div>' :
      '<div class="t"><div class="top"><a class="n" href="' + esc(it.url) + '"><b class="n">' + t + '</b></a><span class="pr">' + money(it.final_line_price) +
      (it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '') + '</span></div>' +
      (meta.length ? '<span class="meta">' + meta.join(' · ') + '</span>' : '') + extra +
      '<div class="ctl"><div class="qty2"><button type="button" aria-label="Decrease quantity of ' + t + '" data-np-qty="-1">&minus;</button><output aria-live="polite">' + it.quantity + '</output><button type="button" aria-label="Increase quantity of ' + t + '" data-np-qty="1">+</button></div>' +
      '<button type="button" class="rm" data-np-rm>Remove<span class="sr"> ' + t + '</span></button></div></div></div>');
  }
  function fdbInner(sub){
    var left = TH - sub, pct = TH > 0 ? Math.min(100, Math.floor(sub * 100 / TH)) : 100;
    return (left <= 0
      ? '<p><svg class="i sm" style="color:#3F6212" aria-hidden="true"><use href="#i-check"/></svg><b>Free next-day delivery unlocked</b></p>'
      : '<p><svg class="i sm" aria-hidden="true"><use href="#i-truck"/></svg><span>Add <b>' + money(left) + '</b> for free next-day delivery</span></p>') +
      '<div class="bar" role="progressbar" aria-label="Progress to free delivery" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><i style="width:' + pct + '%"></i></div>' +
      '<span class="when"><svg class="i sm" aria-hidden="true"><use href="#i-clock"/></svg><span data-np-cutoff></span></span>';
  }
  function paintCutoff(root){
    if(!NP.cutoff) return;
    var c = NP.cutoff();
    root.querySelectorAll('[data-np-cutoff]').forEach(function(el){
      el.innerHTML = c.open ? 'Order in <b>' + c.h + 'h ' + c.m + 'm</b> for delivery <b>' + c.day + '</b> (UK)' : 'Order now for delivery <b>' + c.day + '</b> (UK)';
    });
  }

  /* ---------- render ---------- */
  function render(cart){
    NP.cart = cart;
    var empty = cart.item_count === 0, sub = cart.items_subtotal_price;
    document.querySelectorAll('[data-np-cart]').forEach(function(root){
      root.classList.remove('busy');
      root.querySelectorAll('[data-np-full]').forEach(function(x){ x.hidden = empty; });
      root.querySelectorAll('[data-np-empty]').forEach(function(x){ x.hidden = !empty; });
      root.querySelectorAll('[data-np-count]').forEach(function(x){ x.textContent = cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's'); x.hidden = empty; });
      root.querySelectorAll('[data-np-fdb]').forEach(function(x){ x.className = 'fdb' + (sub >= TH ? ' done' : ''); x.innerHTML = fdbInner(sub); });
      root.querySelectorAll('[data-np-lines]').forEach(function(x){ x.innerHTML = cart.items.map(lineHtml).join(''); });
      root.querySelectorAll('[data-np-sub]').forEach(function(x){ x.textContent = money(sub); });
      root.querySelectorAll('[data-np-total]').forEach(function(x){ x.textContent = money(cart.total_price); });
      root.querySelectorAll('[data-np-deliv]').forEach(function(x){ x.innerHTML = sub >= TH ? '<b style="color:#3F6212">Free next-day</b>' : 'From £3.99'; });
      root.querySelectorAll('[data-np-klarna]').forEach(function(x){ x.innerHTML = 'Or 3 interest-free payments of <strong>' + money(Math.floor(cart.total_price / 3)) + '</strong> with <b>Klarna.</b>'; });
      root.querySelectorAll('[data-np-discounts]').forEach(function(x){
        var cls = root.dataset.npCart === 'page' ? 'row dsc' : 'sub dsc';
        x.innerHTML = (cart.cart_level_discount_applications || []).map(function(d){ return '<div class="' + cls + '"><span>' + esc(d.title) + '</span><span>&minus;' + money(d.total_allocated_amount) + '</span></div>'; }).join('');
      });
      root.querySelectorAll('[data-np-addon]').forEach(function(b){
        var inCart = cart.items.some(function(i){ return String(i.variant_id) === b.dataset.npAddon; });
        b.disabled = false;
        b.setAttribute('aria-pressed', inCart ? 'true' : 'false');
        var name = (b.getAttribute('aria-label') || '').replace(/^(Add|Remove) /, '');
        b.setAttribute('aria-label', (inCart ? 'Remove ' : 'Add ') + name);
        b.innerHTML = inCart ? '<svg class="i sm" aria-hidden="true"><use href="#i-check"/></svg>Added' : '<svg class="i sm" aria-hidden="true"><use href="#i-plus"/></svg>Add';
      });
      paintCutoff(root);
    });
    fillLevels(cart);
  }
  /* rackets added on this page have no level data yet: read it from the server-rendered drawer lines once */
  var tried = {};
  function fillLevels(cart){
    var miss = cart.items.filter(function(i){ return i.product_type === 'Padel Racket' && !levels[i.product_id] && !tried[i.product_id]; });
    if(!miss.length) return;
    miss.forEach(function(i){ tried[i.product_id] = 1; });
    fetch(((NP.routes && NP.routes.cart) || '/cart') + '?section_id=np-cart-drawer').then(function(r){ return r.text(); }).then(function(t){
      var doc = new DOMParser().parseFromString(t, 'text/html'), got = false;
      doc.querySelectorAll('.line[data-pid][data-lvl]').forEach(function(l){ if(l.dataset.lvl && !levels[l.dataset.pid]){ levels[l.dataset.pid] = { txt: l.dataset.lvl, top: +l.dataset.lvt }; got = true; } });
      if(got && NP.cart) render(NP.cart);
    }).catch(function(){});
  }

  function say(msg){ var l = document.querySelector('[data-np-live]'); if(l){ l.textContent = ''; setTimeout(function(){ l.textContent = msg; }, 50); } }

  document.addEventListener('np:cart:changed', function(e){
    var c = e.detail;
    if(!c || !Array.isArray(c.items)){
      /* /cart/change.js error (e.g. not enough stock): show why and resync */
      if(c && (c.description || c.message)) { say(c.description || c.message); alert(c.description || c.message); }
      if(NP.refreshCart) NP.refreshCart();
      return;
    }
    render(c);
    say('Basket updated. ' + c.item_count + ' item' + (c.item_count === 1 ? '' : 's') + ', subtotal ' + money(c.items_subtotal_price) + '.');
  });

  /* ---------- open / close ---------- */
  function open(){
    if(!drawer) return;
    if(isCartPage) return; /* the basket page re-renders itself */
    lastFocus = document.activeElement;
    drawer.classList.add('on');
    document.body.classList.add('np-lock');
    paintCutoff(drawer);
    var a = drawer.querySelector('.drawer'); setTimeout(function(){ a && a.focus(); }, 40);
  }
  function close(){
    if(!drawer || !drawer.classList.contains('on')) return;
    drawer.classList.remove('on');
    document.body.classList.remove('np-lock');
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('np:cart:open', open);
  NP.closeCart = close;

  /* ---------- note (stored as the cart note) ---------- */
  var nt;
  function saveNote(v){
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: v }) })
      .then(function(r){ return r.json(); });
  }
  document.addEventListener('input', function(e){
    var n = e.target.closest('[data-np-note]'); if(!n) return;
    document.querySelectorAll('[data-np-note]').forEach(function(o){ if(o !== n) o.value = n.value; });
    clearTimeout(nt); nt = setTimeout(function(){ saveNote(n.value); }, 600);
  });

  /* ---------- clicks ---------- */
  document.addEventListener('click', function(e){
    var t;
    if((t = e.target.closest('[data-np-opencart]')) && drawer && !isCartPage){ e.preventDefault(); open(); return; }
    if(e.target.closest('[data-np-closecart]')){ close(); return; }
    if((t = e.target.closest('[data-np-notebtn]'))){
      var on = t.getAttribute('aria-expanded') !== 'true';
      t.setAttribute('aria-expanded', on ? 'true' : 'false');
      var p = document.getElementById(t.getAttribute('aria-controls')); if(p){ p.hidden = !on; if(on){ var ta = p.querySelector('textarea'); if(ta) ta.focus(); } }
      return;
    }
    if((t = e.target.closest('[data-np-qty],[data-np-rm]'))){
      var line = t.closest('.line'); if(!line || !NP.changeLine) return;
      var q = parseInt((line.querySelector('output') || {}).textContent, 10) || 0;
      var nq = t.hasAttribute('data-np-rm') ? 0 : Math.max(0, q + parseInt(t.dataset.npQty, 10));
      line.classList.add('busy');
      NP.changeLine(line.dataset.key, nq).catch(function(){ NP.refreshCart && NP.refreshCart(); });
      return;
    }
    if((t = e.target.closest('[data-np-addon]'))){
      var vid = t.dataset.npAddon;
      t.disabled = true;
      if(t.getAttribute('aria-pressed') === 'true'){
        (NP.cart ? Promise.resolve(NP.cart) : NP.getCart()).then(function(c){
          var it = c.items.filter(function(i){ return String(i.variant_id) === vid; })[0];
          return it ? NP.changeLine(it.key, 0) : NP.refreshCart();
        }).catch(function(){ t.disabled = false; });
      } else {
        NP.addItems([{ id: +vid, quantity: 1 }]).catch(function(err){
          t.disabled = false;
          if(!(err && err.silent)) alert((err && (err.description || err.message)) || 'Sorry, that could not be added.');
        });
      }
    }
  });

  /* ---------- keyboard: Escape + focus trap ---------- */
  document.addEventListener('keydown', function(e){
    if(!drawer || !drawer.classList.contains('on')) return;
    if(e.key === 'Escape'){ close(); return; }
    if(e.key !== 'Tab') return;
    var f = [].slice.call(drawer.querySelectorAll('a[href],button:not([disabled]),textarea,input:not([type=hidden]),[tabindex]:not([tabindex="-1"])')).filter(function(x){ return x.offsetParent !== null; });
    if(!f.length) return;
    if(e.shiftKey && (document.activeElement === f[0] || document.activeElement === drawer.querySelector('.drawer'))){ e.preventDefault(); f[f.length-1].focus(); }
    else if(!e.shiftKey && document.activeElement === f[f.length-1]){ e.preventDefault(); f[0].focus(); }
  });

  /* ---------- first paint ---------- */
  document.querySelectorAll('[data-np-cart]').forEach(paintCutoff);
  /* back/forward cache can show a stale basket: resync */
  window.addEventListener('pageshow', function(e){ if(e.persisted && NP.refreshCart) NP.refreshCart(); });
})();
